import { render, staticRenderFns } from "./proswipe.vue?vue&type=template&id=6003f9e1&scoped=true"
import script from "./proswipe.vue?vue&type=script&lang=js"
export * from "./proswipe.vue?vue&type=script&lang=js"
import style0 from "./proswipe.vue?vue&type=style&index=0&id=6003f9e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6003f9e1",
  null
  
)

export default component.exports